export default "__VITE_ASSET__jbof6fCw__"